import { recordPath, recordRoute } from '@/shared/registry'

/** Where the course assignment pages live. */
export const courseAssignmentsPath = '/entitlements/course-assignments'
export const createCourseAssignmentPath = `${courseAssignmentsPath}/new`
export const courseAssignmentRoute = recordRoute('entitlements', 'course-assignments')
export const editCourseAssignmentRoute = `${courseAssignmentRoute}/edit`

/** A course assignment's details page. */
export function courseAssignmentPath(id: string): string {
  return recordPath('entitlements', 'course-assignments', id)
}

/** A course assignment's edit page. */
export function editCourseAssignmentPath(id: string): string {
  return `${courseAssignmentPath(id)}/edit`
}

/** Find Course Assignments showing one person's, as User Details links to it. */
export function personCourseAssignmentsPath(userId: string): string {
  return `${courseAssignmentsPath}?${new URLSearchParams({ filter: `userId:equals:${userId}` }).toString()}`
}

/** Create Course Assignment with one person already chosen, as User Details links to it. */
export function createPersonCourseAssignmentPath(userId: string): string {
  return `${createCourseAssignmentPath}?${new URLSearchParams({ userId }).toString()}`
}

/**
 * The base of Course Assignment Details' slots (`detailsSlots`): Learner History's completion
 * actions (LH-14) go in its `actions`.
 */
export const courseAssignmentDetailsSlot = 'entitlements.course-assignment-details'

/**
 * The course's activities for the person, on Course Assignment Details' Activities tab and on the
 * simple learner page: Launch's activity list (LCH) registers here, as a panel given the
 * assignment's id.
 */
export const courseAssignmentActivitiesSlot = 'entitlements.course-assignment.activities'

/** The permission skipping prerequisites needs, besides the subscription permissions. */
export const bypassSubscriptionsPermission = 'entitlements.subscriptions.prerequisite-bypass.write'

/** The API's course assignment endpoints: the subscriptions' of kind course. */
export const courseAssignmentsApi = '/entitlements/v1/subscriptions/course-assignments'
